/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBan = createReactComponent("outline", "ban", "IconBan", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M5.7 5.7l12.6 12.6", "key": "svg-1" }]]);

export { IconBan as default };
//# sourceMappingURL=IconBan.mjs.map
